module.exports = __webpack_public_path__ + "static/media/SHSProdIcons_Smartwatch.6b4dbc25.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/homepage/resources/SHSProdIcons_Smartwatch.svg
// module id = 1611
// module chunks = 0